<template>
  <aside
    class="border-r border-gray-10 h-full shadow z-10 relative"
    style="width: 500px"
  >
    <header class="p-4 font-medium text-lg">
      Sök trafikplatser
    </header>

    <TrafficLocationsSearch />
    <AppTransition>
      <TrafficLocationsResultTable
        @center-path="$emit('center-path')"
        @clear="$emit('clear')"
        v-if="shortestPath.length"
      />
    </AppTransition>
  </aside>
</template>

<script>
import TrafficLocationsSearch from './TrafficLocationsSearch'
import TrafficLocationsResultTable from './TrafficLocationsResultTable'
import { get } from 'vuex-pathify'

export default {
  name: 'TrafficLocationsSidebar',

  components: {
    TrafficLocationsSearch,
    TrafficLocationsResultTable
  },

  computed: {
    shortestPath: get('routeLinks/shortestPath@data')
  }
}
</script>
